<app-title-ayuda-component [title]="pageTitle"></app-title-ayuda-component>
<div class="container">
  <span
    >
    {{ helpContent()?.firstPartOfSupportDescription }}      
      <a href="{{ helpContent()?.linkToSupportLabel }}">Soporte</a> 
      {{helpContent()?.lastPartOfSupportDescription}}
      </span
  >
</div>
